import { render, staticRenderFns } from "./sendStudyOrder.vue?vue&type=template&id=a5ca32d4&scoped=true"
import script from "./sendStudyOrder.vue?vue&type=script&lang=js"
export * from "./sendStudyOrder.vue?vue&type=script&lang=js"
import style0 from "./sendStudyOrder.vue?vue&type=style&index=0&id=a5ca32d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ca32d4",
  null
  
)

export default component.exports